import { render } from "./TitleButtonHospital.vue?vue&type=template&id=c9156c9c&scoped=true"
import script from "./TitleButtonHospital.vue?vue&type=script&lang=js"
export * from "./TitleButtonHospital.vue?vue&type=script&lang=js"

import "./TitleButtonHospital.vue?vue&type=style&index=0&id=c9156c9c&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9156c9c"]])

export default __exports__